// Color utility functions for areas management

export const getAreaColor = (areaId?: number): string => {
    const colors = [
        '#3b82f6', // blue
        '#10b981', // green
        '#f59e0b', // amber
        '#ef4444', // red
        '#8b5cf6', // violet
        '#06b6d4', // cyan (replaces pink)
        '#84cc16', // lime
        '#f97316'  // orange (new color to maintain 8 colors)
    ];
    
    if (areaId === undefined || areaId === null) {
        // For temporary areas (during creation), use green
        return '#10b981';
    }
    
    return colors[areaId % colors.length];
};
